import React, { useState, useCallback, useEffect } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useIntl } from "react-intl";

import Consignment from "../consignment";
import { getEntity } from "../../modules/crudOperations";
import LoadError from "../../components/app/generic/loadError";

function ConsignmentEdit() {
  const intl = useIntl();
  const { consignmentId } = useParams();
  const { pathname } = useLocation();
  const [realEditing] = useState(!pathname.endsWith("add"));

  const history = useHistory();
  const handleClick = useCallback(() => {
    history.goBack();
  }, [history]);

  const [loading, setLoading] = useState();
  const [consignment, setConsignment] = useState();
  const loadConsignment = useCallback(() => {
    setLoading(true);
    getEntity("consignment", consignmentId, setLoading, setConsignment);
  }, [consignmentId]);

  useEffect(() => {
    loadConsignment();
  }, [loadConsignment]);

  return consignment &&
    consignment.state !== "NE" &&
    consignment.state !== "CP" ? (
    <LoadError
      buttonText={intl.formatMessage({
        id: "messages.back",
        defaultMessage: "Zpět",
      })}
      onClick={handleClick}
      message={
        consignment && consignment !== "e"
          ? intl.formatMessage({
              id: "consignment.edit.try",
              defaultMessage: "Zásilku již nelze editovat!",
            })
          : intl.formatMessage({
              id: "consignment.unknown",
              defaultMessage: "Neznámá zásilka!",
            })
      }
    />
  ) : (
    <Consignment
      loading={loading}
      edit={realEditing}
      consignment={consignment}
      fromTemplate={!realEditing}
      onLoadConsignment={realEditing && loadConsignment}
    />
  );
}

export default ConsignmentEdit;
